export interface IScrollTo {
  containerElement: HTMLElement;
  targetElement: HTMLElement;
  parentElement: HTMLElement;
  center: boolean;
}

export const scrollTo = (params: IScrollTo) => {
  const containerElementClientHeight = params.containerElement.clientHeight;
  const containerElementScrollTop = params.containerElement.scrollTop;
  const parentElementOffsetTop = params.parentElement.offsetTop;
  const parentElementScrollHeight = params.parentElement.scrollHeight;
  const targetElementOffsetTop = params.targetElement.offsetTop;
  const targetElementScrollHeight = params.targetElement.scrollHeight;

  const containerBottom = containerElementScrollTop + containerElementClientHeight;
  const valueBottom = targetElementOffsetTop
    + targetElementScrollHeight
    + parentElementOffsetTop
    + parentElementScrollHeight;

  if (valueBottom > containerBottom) {
    params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
  } else if (targetElementOffsetTop + parentElementOffsetTop < containerElementScrollTop) {
    params.containerElement.scrollTop = targetElementOffsetTop + parentElementOffsetTop - 18;
  }
}

export const getOfferType = (buildingType: string): string => {
  switch (buildingType) {
    case 'flat':
    case 'bed':
    case 'secondary_flat':
    case 'room':
    case 'part':
      return 'flat';
    case 'house':
    case 'housepart':
    case 'townhouse':
    case 'sector':
      return 'suburban';
    case 'new_flat':
      return 'newbuilding';
    default:
      return 'commercial';
  }
};
